export const hasFinanceFileReference = (file = {}) => Boolean(
  file.dataUrl || file.url || file.contentPath || file.downloadPath || file.downloadUrl || file.relativePath
);

export const normalizeFinanceAttachment = (attachment = {}, fallback = {}) => ({
  id: attachment.id || fallback.id,
  name: attachment.name || fallback.name || "Documento financeiro",
  type: attachment.type || fallback.type || "",
  size: attachment.size || fallback.size || "",
  dataUrl: attachment.dataUrl || (/^(data:|blob:)/i.test(attachment.url || "") ? attachment.url : ""),
  url: attachment.url || "",
  contentPath: attachment.contentPath || "",
  downloadPath: attachment.downloadPath || "",
  downloadUrl: attachment.downloadUrl || "",
  relativePath: attachment.relativePath || "",
  category: fallback.category || "Financeiro",
  uploadedAt: attachment.uploadedAt || attachment.createdAt || fallback.uploadedAt || "",
  sourceName: fallback.sourceName || "",
  sourceDate: fallback.sourceDate || "",
  accountName: fallback.accountName || "",
  transactionDescription: fallback.transactionDescription || "",
});

export const buildForecastFiles = (forecastExpenses = []) => (
  Array.isArray(forecastExpenses) ? forecastExpenses : []
).flatMap((entry) => {
  const attachments = Array.isArray(entry?.attachments) ? entry.attachments : [];
  return attachments.map((attachment, index) => normalizeFinanceAttachment(attachment, {
    id: attachment.id || `${entry.id || entry.name || "forecast"}-${index}`,
    name: attachment.name || "Anexo da previsão",
    category: "Previsão de despesas",
    uploadedAt: entry.occurrenceDate || entry.date || "",
    sourceName: entry.name || "Despesa prevista",
    sourceDate: entry.occurrenceDate || entry.date || "",
  }));
});
